import { DeleteEntryModal } from './DeleteEntryModal';

export default DeleteEntryModal;
